import { withInstall } from '@xzx-design/utils'
import _Text from './src/text.vue'

export const Text = withInstall(_Text)
export default Text

export * from './src/text'
